/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StationsIndexRouteImport } from './routes/stations/index'
import { Route as PresetsIndexRouteImport } from './routes/presets/index'
import { Route as MapIndexRouteImport } from './routes/map/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as GroupsStationsIndexRouteImport } from './routes/groups-stations/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUserGroupsRouteImport } from './routes/admin/user-groups'
import { Route as AdminStationTypesRouteImport } from './routes/admin/station-types'
import { Route as AdminScreenPresetsRouteImport } from './routes/admin/screen-presets'
import { Route as AdminOrgsRouteImport } from './routes/admin/orgs'
import { Route as AdminAmpfConfigsRouteImport } from './routes/admin/ampf-configs'
import { Route as DashboardTemperaturesUnitSerialNumberRouteImport } from './routes/dashboard/temperatures/$unitSerialNumber'
import { Route as StationsClassicStationIdIndexRouteImport } from './routes/stations/classic/$stationId/index'

const StationAccessIndexLazyRouteImport = createFileRoute('/station-access/')()
const SettingsIndexLazyRouteImport = createFileRoute('/settings/')()
const EventsIndexLazyRouteImport = createFileRoute('/events/')()
const StationsSingleStationIdIndexLazyRouteImport = createFileRoute(
  '/stations/single/$stationId/',
)()

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/route.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StationAccessIndexLazyRoute = StationAccessIndexLazyRouteImport.update({
  id: '/station-access/',
  path: '/station-access/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/station-access/index.lazy').then((d) => d.Route),
)
const SettingsIndexLazyRoute = SettingsIndexLazyRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)
const EventsIndexLazyRoute = EventsIndexLazyRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/events/index.lazy').then((d) => d.Route))
const StationsIndexRoute = StationsIndexRouteImport.update({
  id: '/stations/',
  path: '/stations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stations/index.lazy').then((d) => d.Route),
)
const PresetsIndexRoute = PresetsIndexRouteImport.update({
  id: '/presets/',
  path: '/presets/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/presets/index.lazy').then((d) => d.Route))
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/map/',
  path: '/map/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/map/index.lazy').then((d) => d.Route))
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))
const GroupsStationsIndexRoute = GroupsStationsIndexRouteImport.update({
  id: '/groups-stations/',
  path: '/groups-stations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/groups-stations/index.lazy').then((d) => d.Route),
)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/users.lazy').then((d) => d.Route))
const AdminUserGroupsRoute = AdminUserGroupsRouteImport.update({
  id: '/user-groups',
  path: '/user-groups',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/user-groups.lazy').then((d) => d.Route),
)
const AdminStationTypesRoute = AdminStationTypesRouteImport.update({
  id: '/station-types',
  path: '/station-types',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/station-types.lazy').then((d) => d.Route),
)
const AdminScreenPresetsRoute = AdminScreenPresetsRouteImport.update({
  id: '/screen-presets',
  path: '/screen-presets',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/screen-presets.lazy').then((d) => d.Route),
)
const AdminOrgsRoute = AdminOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/orgs.lazy').then((d) => d.Route))
const AdminAmpfConfigsRoute = AdminAmpfConfigsRouteImport.update({
  id: '/ampf-configs',
  path: '/ampf-configs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/ampf-configs.lazy').then((d) => d.Route),
)
const DashboardTemperaturesUnitSerialNumberRoute =
  DashboardTemperaturesUnitSerialNumberRouteImport.update({
    id: '/dashboard/temperatures/$unitSerialNumber',
    path: '/dashboard/temperatures/$unitSerialNumber',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/dashboard/temperatures/$unitSerialNumber.lazy').then(
      (d) => d.Route,
    ),
  )
const StationsSingleStationIdIndexLazyRoute =
  StationsSingleStationIdIndexLazyRouteImport.update({
    id: '/stations/single/$stationId/',
    path: '/stations/single/$stationId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/stations/single/$stationId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const StationsClassicStationIdIndexRoute =
  StationsClassicStationIdIndexRouteImport.update({
    id: '/stations/classic/$stationId/',
    path: '/stations/classic/$stationId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/stations/classic/$stationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-types': typeof AdminStationTypesRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/groups-stations': typeof GroupsStationsIndexRoute
  '/login': typeof LoginIndexRoute
  '/map': typeof MapIndexRoute
  '/presets': typeof PresetsIndexRoute
  '/stations': typeof StationsIndexRoute
  '/events': typeof EventsIndexLazyRoute
  '/settings': typeof SettingsIndexLazyRoute
  '/station-access': typeof StationAccessIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-types': typeof AdminStationTypesRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/groups-stations': typeof GroupsStationsIndexRoute
  '/login': typeof LoginIndexRoute
  '/map': typeof MapIndexRoute
  '/presets': typeof PresetsIndexRoute
  '/stations': typeof StationsIndexRoute
  '/events': typeof EventsIndexLazyRoute
  '/settings': typeof SettingsIndexLazyRoute
  '/station-access': typeof StationAccessIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-types': typeof AdminStationTypesRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/groups-stations/': typeof GroupsStationsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/map/': typeof MapIndexRoute
  '/presets/': typeof PresetsIndexRoute
  '/stations/': typeof StationsIndexRoute
  '/events/': typeof EventsIndexLazyRoute
  '/settings/': typeof SettingsIndexLazyRoute
  '/station-access/': typeof StationAccessIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId/': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId/': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin/ampf-configs'
    | '/admin/orgs'
    | '/admin/screen-presets'
    | '/admin/station-types'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin/'
    | '/dashboard'
    | '/groups-stations'
    | '/login'
    | '/map'
    | '/presets'
    | '/stations'
    | '/events'
    | '/settings'
    | '/station-access'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId'
    | '/stations/single/$stationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/ampf-configs'
    | '/admin/orgs'
    | '/admin/screen-presets'
    | '/admin/station-types'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin'
    | '/dashboard'
    | '/groups-stations'
    | '/login'
    | '/map'
    | '/presets'
    | '/stations'
    | '/events'
    | '/settings'
    | '/station-access'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId'
    | '/stations/single/$stationId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin/ampf-configs'
    | '/admin/orgs'
    | '/admin/screen-presets'
    | '/admin/station-types'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin/'
    | '/dashboard/'
    | '/groups-stations/'
    | '/login/'
    | '/map/'
    | '/presets/'
    | '/stations/'
    | '/events/'
    | '/settings/'
    | '/station-access/'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId/'
    | '/stations/single/$stationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  GroupsStationsIndexRoute: typeof GroupsStationsIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  MapIndexRoute: typeof MapIndexRoute
  PresetsIndexRoute: typeof PresetsIndexRoute
  StationsIndexRoute: typeof StationsIndexRoute
  EventsIndexLazyRoute: typeof EventsIndexLazyRoute
  SettingsIndexLazyRoute: typeof SettingsIndexLazyRoute
  StationAccessIndexLazyRoute: typeof StationAccessIndexLazyRoute
  DashboardTemperaturesUnitSerialNumberRoute: typeof DashboardTemperaturesUnitSerialNumberRoute
  StationsClassicStationIdIndexRoute: typeof StationsClassicStationIdIndexRoute
  StationsSingleStationIdIndexLazyRoute: typeof StationsSingleStationIdIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/station-access/': {
      id: '/station-access/'
      path: '/station-access'
      fullPath: '/station-access'
      preLoaderRoute: typeof StationAccessIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/': {
      id: '/stations/'
      path: '/stations'
      fullPath: '/stations'
      preLoaderRoute: typeof StationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/presets/': {
      id: '/presets/'
      path: '/presets'
      fullPath: '/presets'
      preLoaderRoute: typeof PresetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map/': {
      id: '/map/'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groups-stations/': {
      id: '/groups-stations/'
      path: '/groups-stations'
      fullPath: '/groups-stations'
      preLoaderRoute: typeof GroupsStationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/user-groups': {
      id: '/admin/user-groups'
      path: '/user-groups'
      fullPath: '/admin/user-groups'
      preLoaderRoute: typeof AdminUserGroupsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/station-types': {
      id: '/admin/station-types'
      path: '/station-types'
      fullPath: '/admin/station-types'
      preLoaderRoute: typeof AdminStationTypesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/screen-presets': {
      id: '/admin/screen-presets'
      path: '/screen-presets'
      fullPath: '/admin/screen-presets'
      preLoaderRoute: typeof AdminScreenPresetsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/orgs': {
      id: '/admin/orgs'
      path: '/orgs'
      fullPath: '/admin/orgs'
      preLoaderRoute: typeof AdminOrgsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ampf-configs': {
      id: '/admin/ampf-configs'
      path: '/ampf-configs'
      fullPath: '/admin/ampf-configs'
      preLoaderRoute: typeof AdminAmpfConfigsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/dashboard/temperatures/$unitSerialNumber': {
      id: '/dashboard/temperatures/$unitSerialNumber'
      path: '/dashboard/temperatures/$unitSerialNumber'
      fullPath: '/dashboard/temperatures/$unitSerialNumber'
      preLoaderRoute: typeof DashboardTemperaturesUnitSerialNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/single/$stationId/': {
      id: '/stations/single/$stationId/'
      path: '/stations/single/$stationId'
      fullPath: '/stations/single/$stationId'
      preLoaderRoute: typeof StationsSingleStationIdIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/classic/$stationId/': {
      id: '/stations/classic/$stationId/'
      path: '/stations/classic/$stationId'
      fullPath: '/stations/classic/$stationId'
      preLoaderRoute: typeof StationsClassicStationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAmpfConfigsRoute: typeof AdminAmpfConfigsRoute
  AdminOrgsRoute: typeof AdminOrgsRoute
  AdminScreenPresetsRoute: typeof AdminScreenPresetsRoute
  AdminStationTypesRoute: typeof AdminStationTypesRoute
  AdminUserGroupsRoute: typeof AdminUserGroupsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAmpfConfigsRoute: AdminAmpfConfigsRoute,
  AdminOrgsRoute: AdminOrgsRoute,
  AdminScreenPresetsRoute: AdminScreenPresetsRoute,
  AdminStationTypesRoute: AdminStationTypesRoute,
  AdminUserGroupsRoute: AdminUserGroupsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  GroupsStationsIndexRoute: GroupsStationsIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MapIndexRoute: MapIndexRoute,
  PresetsIndexRoute: PresetsIndexRoute,
  StationsIndexRoute: StationsIndexRoute,
  EventsIndexLazyRoute: EventsIndexLazyRoute,
  SettingsIndexLazyRoute: SettingsIndexLazyRoute,
  StationAccessIndexLazyRoute: StationAccessIndexLazyRoute,
  DashboardTemperaturesUnitSerialNumberRoute:
    DashboardTemperaturesUnitSerialNumberRoute,
  StationsClassicStationIdIndexRoute: StationsClassicStationIdIndexRoute,
  StationsSingleStationIdIndexLazyRoute: StationsSingleStationIdIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
